'use client';

import { css } from '@bts-web/utils-style-engine';
import { Drawer, HyperLinkButtonBase } from '../../common';
import { useModalDrawerContext } from '../../common/components/ModalDrawerContext/ModalDrawerContext';

const UK_RISK_SUMMARY_URL =
  'https://www.bitpanda.com/en-gb/legal/uk-risk-summary';

interface AssetRisksDrawerProps {
  title: string;
  body: string;
  ctaLabel: string;
}

const AssetRisksDrawer = ({ title, body, ctaLabel }: AssetRisksDrawerProps) => {
  const { close } = useModalDrawerContext();

  return (
    <Drawer>
      <div
        className={css({
          padding: 'medium',
          display: 'flex',
          flexDirection: 'column',
          gap: 'medium',
          height: '100%',
        })}
      >
        <h4
          className={css({
            fontSize: 'headline.medium_medium',
            fontWeight: 'headline.medium_medium',
            letterSpacing: 'headline.medium_medium',
            lineHeight: 'headline.medium_medium',
            textAlign: 'center',
          })}
        >
          {title}
        </h4>

        <p
          className={css({
            fontSize: 'body.medium',
            lineHeight: 'body.medium',
            letterSpacing: 'body.medium',
            color: 'neutrals.text_primary',
            textAlign: 'center',
          })}
        >
          {body}
        </p>

        <div
          className={css({
            display: 'flex',
            justifyContent: 'center',
            marginTop: 'auto',
          })}
        >
          <HyperLinkButtonBase
            visual="secondary"
            size="large"
            to={UK_RISK_SUMMARY_URL}
            onClick={() => close()}
          >
            {ctaLabel}
          </HyperLinkButtonBase>
        </div>
      </div>
    </Drawer>
  );
};

export { AssetRisksDrawer };
